import { createAsyncThunk } from '@reduxjs/toolkit';
import { machineService } from 'services';

export const filterListPatient = createAsyncThunk<any, string>('list/Patient', async (params) => {
  const response = await machineService.listPatient(params);

  return response.data.report_results;
});

export const updateDevice = createAsyncThunk<any, string[]>('update/Machine', async (params) => {
  try {
    const response = await machineService.changeStatusItem(params);
    return response;
  } catch (error) {
    console.log('error', error);
  }
});

export const updateBackDevice = createAsyncThunk<any, string[]>('update/Machine', async (params) => {
  try {
    const response = await machineService.changeStatusBackItem(params);
    return response;
  } catch (error) {
    console.log('error', error);
  }
});
